import { generateId } from '@freelancer/datastore/testing';
import { PoolModel } from './pools.model';

export interface GeneratePoolOptions {
  readonly name: string;
  readonly displayName: string;
  readonly isTalentNetwork: boolean;
  readonly isTestPool: boolean;
  readonly dateCreated?: number;
}

export function generatePoolObject({
  name,
  displayName,
  isTalentNetwork = false,
  isTestPool = false,
  dateCreated = Date.now(),
}: GeneratePoolOptions): PoolModel {
  return {
    id: generateId(),
    name,
    displayName,
    isTalentNetwork,
    isTestPool,
    dateCreated,
  };
}

export function generatePoolObjects(
  pools: readonly PoolModel[],
): readonly PoolModel[] {
  return pools;
}

export function freelancerPool(): PoolModel {
  return {
    id: 1,
    name: 'freelancer',
    displayName: 'Freelancer',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: 1615764653,
  };
}

export function deloittePool(): PoolModel {
  return {
    id: 2,
    name: 'deloitte_dc',
    displayName: 'Deloitte',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: 1615764653,
  };
}

export function arrowPool(): PoolModel {
  return {
    id: 3,
    name: 'arrow',
    displayName: 'Arrow',
    isTalentNetwork: false,
    isTestPool: false,
    dateCreated: 1615764653,
  };
}

export function facebookPool(): PoolModel {
  return {
    id: 4,
    name: 'facebook',
    displayName: 'Facebook',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: 1615764653,
  };
}

export function talentNetworkPool(): PoolModel {
  return {
    id: 11,
    name: 'big_talent_marketplace',
    displayName: 'Big Talent Marketplace',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: 1615764653,
  };
}

export function anotherTalentNetworkPool(): PoolModel {
  return {
    id: 12,
    name: 'spectacular_seeds',
    displayName: 'Spectacular Seeds Ltd',
    isTalentNetwork: true,
    isTestPool: false,
    dateCreated: 1615764653,
  };
}
